import { useCallback, useMemo, useRef, useState } from 'react'
import { debounce } from 'lodash'
import { ADDRESS_SEARCH_DEBOUNCE_MS } from 'config'

export default function useAddressSearch(autoCompleteAddress) {
  const [searchResults, setSearchResults] = useState(null)
  const [resultsPanelOpen, setResultsPanelOpen] = useState(false)

  const closePanel = useCallback(() => setResultsPanelOpen(false), [])

  const handleSearch = useCallback(
    async (_, newSearchQuery) => {
      const normalizedSearchQuery = newSearchQuery.split(' ').join('+')
      const placeSearchResult = await autoCompleteAddress(normalizedSearchQuery)
      setSearchResults(placeSearchResult.results)
      setResultsPanelOpen(true)
    },
    [autoCompleteAddress],
  )

  const handleSearchRef = useRef(handleSearch)
  handleSearchRef.current = handleSearch
  const onAddressInputChange = useMemo(
    () =>
      debounce((...args) => {
        handleSearchRef.current(...args)
      }, ADDRESS_SEARCH_DEBOUNCE_MS),
    [],
  )

  return {
    searchResults,
    resultsPanelOpen,
    closePanel,
    onAddressInputChange,
  }
}
